// Copyright (c) 2020 Comsearch, Inc., All rights reserved

// NOTE - this isn't a columns array for DataTable.
// We need to render a custom table here so we can't use that

// NOTE - we don't actually have the first column in this array because we are treating it special
// in three different places and leaving it outside of this data model makes finagling it easier.

export default [{
  columnHeader: 'Site Name',
  columnKey: 'siteName',
}, {
  columnHeader: 'Site Status',
  columnKey: 'segmentStatusAbbreviation',
}, {
  columnHeader: 'Call Sign',
  columnKey: 'callSign',
}, {
  columnHeader: 'Contact',
  columnKey: 'serviceContactCode',
}, {
  columnHeader: 'Latitude',
  columnKey: 'latitude',
}, {
  columnHeader: 'Longitude',
  columnKey: 'longitude',
}, {
  columnHeader: 'G.E. (m/ft)',
  columnKey: 'groundElevation',
}, {
  columnHeader: 'ASR',
  columnKey: 'asr',
}, {
  columnHeader: 'Band',
  columnKey: 'band',
}, {
  columnHeader: 'RCN',
  columnKey: 'rcnNumber',
}]
